import isArray from 'lodash/isArray';

type ParamValue = ParamValue[] | boolean | number | string | undefined;
type Params = { [key: string]: ParamValue };

export const queryParamsSerializer = (params: Params): string => {
  return Object.keys(params).reduce((result, key) => {
    if (params[key] === undefined) return result;

    if (result) result += '&';

    if (isArray(params[key])) {
      (params[key] as ParamValue[]).forEach((value: ParamValue, index: number) => {
        result += `${index ? '&' : ''}${key}=${value}`;
      });
    } else {
      let value = params[key];

      if (typeof value === 'boolean') {
        value = value ? 'true' : 'false';
      }

      result += `${key}=${value}`;
    }

    return result;
  }, '');
};
